const QrTicketIcon = () => {
  return (
    <svg
      className="qr_ticket_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="14"
      viewBox="0 0 21 14"
      fill="none"
    >
      <path
        d="M0.5 2C0.5 0.89543 1.39543 0 2.5 0H4.5V14H2.5C1.39543 14 0.5 13.1046 0.5 12V2Z"
        fill="#17171C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 0H6.5V14H18.5C19.6046 14 20.5 13.1046 20.5 12V10C20.5 9.44771 20.0523 9 19.5 9C18.3954 9 17.5 8.10457 17.5 7C17.5 5.89543 18.3954 5 19.5 5C20.0523 5 20.5 4.55228 20.5 4V2C20.5 0.895431 19.6046 0 18.5 0ZM12 3.5C10.067 3.5 8.5 5.067 8.5 7C8.5 8.933 10.067 10.5 12 10.5C13.933 10.5 15.5 8.933 15.5 7C15.5 5.067 13.933 3.5 12 3.5ZM10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7C13.5 7.82843 12.8284 8.5 12 8.5C11.1716 8.5 10.5 7.82843 10.5 7Z"
        fill="#17171C"
      />
    </svg>
  )
}

export default QrTicketIcon
